import React from 'react';

/** Domain → contact → email. Empty slots are skipped. */
function Lineage({ domain, contact, label }) {
  const parts = [domain, contact, label].filter(Boolean);
  if (!parts.length) return null;
  return (
    <span className="inline-flex items-center gap-1.5 min-w-0 text-[12px] text-ink-muted">
      {parts.map((p, i) => (
        <React.Fragment key={`${p}-${i}`}>
          {i > 0 && (
            <span className="text-ink-faint flex-shrink-0" aria-hidden>
              →
            </span>
          )}
          <span className={`truncate ${i === parts.length - 1 ? 'text-ink' : ''}`}>{p}</span>
        </React.Fragment>
      ))}
    </span>
  );
}

export default Lineage;
